/**
 * @file Reads the dir attribute from the html object to detect the direction.
 */
const dir = document.documentElement.dir || 'ltr'

export { dir }
